import { Button, Flex, Form, Input, type FormInstance } from "antd";
import DeleteIcon from "../../../../assets/icons/DeleteIcon";
import FileUpload from "../../../../components/FileUpload";
import AddIcon from "../_icons/AddIcon";

type Props = {
  form: FormInstance<any>;
};

export default function TechnicalInfo({ form }: Props) {
  return (
    <>
      <Form.List initialValue={[{}]} name="technical">
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map(({ key, name, ...restField }, _) => {
                return (
                  <div
                    key={key}
                    className="p-4 rounded-lg border border-theme-zinc-200 mb-3"
                  >
                    {fields.length > 1 && (
                      <Flex justify="end">
                        <Button
                          icon={<DeleteIcon className="text-theme-red-500" />}
                          onClick={() => remove(name)}
                          size="small"
                          type="dashed"
                          className="!size-7"
                        />
                      </Flex>
                    )}
                    <Form.Item
                      {...restField}
                      label="অন্যান্য টেকনিক্যাল সার্টিফিকেট/লাইসেন্স নাম"
                      name={[name, "name"]}
                      rules={[
                        {
                          required: true,
                          message:
                            "অন্যান্য টেকনিক্যাল সার্টিফিকেট/লাইসেন্স নাম",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        placeholder="যেমনঃ ড্রাইভিং লাইসেন্স"
                      />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "url"]}
                      label="লাইসেন্স/সার্টিফিকেট আপলোড করুন"
                      className="mb-4"
                      valuePropName="fileUrl"
                      rules={[
                        {
                          required: true,
                          message: "লাইসেন্স/সার্টিফিকেট আপলোড করুন",
                        },
                      ]}
                    >
                      <FileUpload
                        form={form}
                        accept=".png, .jpg, .jpeg"
                        name={`technical.${name}.url`}
                        onChange={(url) =>
                          form.setFieldsValue({
                            technical: form
                              .getFieldValue("technical")
                              .map((item: any, idx: number) => {
                                if (idx === name) return { ...item, url: url };
                                return item;
                              }),
                          })
                        }
                      />
                    </Form.Item>
                  </div>
                );
              })}

              <Button
                size="small"
                type="text"
                icon={<AddIcon />}
                onClick={() => add()}
                className="!bg-transparent"
              >
                <span className="text-theme-blue-600 text-lg font-medium relative -top-[1px] ml-1">
                  আরো যুক্ত করুন
                </span>
              </Button>
            </>
          );
        }}
      </Form.List>
    </>
  );
}
